var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.1208333px",
    height: "16.3125762px",
    viewBox: "0 0 20.1208333 16.3125762",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.297665551
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres---Cat\\xE9gories---Ajouter",
    transform: "translate(-696.304167, -604.737424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(281.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(414.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 22 0 22 22 0 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41666667,16.5 C4.03493868,16.5 2.10416667,14.6531746 2.10416667,12.375 C2.10416667,10.0968254 4.03493868,8.25 6.41666667,8.25 C6.78054829,6.62890739 8.07772501,5.30567172 9.81956291,4.77874306 C11.5614008,4.25181441 13.4832733,4.60124577 14.8612296,5.69540973 C16.2391859,6.78957369 16.8638816,8.46224072 16.5,10.0833333 L17.4166667,10.0833333 C19.1885802,10.0833334 20.6249999,11.5197531 20.6249999,13.2916667 C20.6249999,15.0635802 19.1885802,16.5 17.4166667,16.5 L16.5,16.5",
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "8.25 13.75 11 11 13.75 13.75"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 11,
    x2: 11,
    y2: 19.25,
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadGrey);
export default __webpack_public_path__ + "static/media/icon_upload_grey.447330f4aebf6e927a997ff679094eb2.svg";
export { ForwardRef as ReactComponent };